import { __decorate, __metadata } from "tslib";
import { PromotionExternalAmountTypeEnum } from '@goparrot/order-sdk';
import { PromotionAmountTypeEnum, PromotionDiscountBehaviourEnum, PromotionDiscountLevelEnum } from '@goparrot/promotions-sdk';
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDefined, IsEnum, IsNotEmpty, IsNumber, IsOptional, IsPositive, ValidateNested } from 'class-validator';
import { LoyaltyProgramExposeGroupEnum } from '../interface';
import { ReadLoyaltyPromotionTargetDto } from './ReadLoyaltyPromotionTargetDto';
export class ReadLoyaltyPromotionDiscountDto {
}
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsNotEmpty({ always: true }),
    IsEnum(PromotionAmountTypeEnum, { always: true }),
    __metadata("design:type", String)
], ReadLoyaltyPromotionDiscountDto.prototype, "amountType", void 0);
__decorate([
    ApiProperty({ enum: PromotionExternalAmountTypeEnum }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ] }),
    __metadata("design:type", String)
], ReadLoyaltyPromotionDiscountDto.prototype, "externalType", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsNotEmpty({ always: true }),
    IsNumber({}, { always: true }),
    IsPositive({ always: true }),
    __metadata("design:type", Number)
], ReadLoyaltyPromotionDiscountDto.prototype, "amount", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsNotEmpty({ always: false }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], ReadLoyaltyPromotionDiscountDto.prototype, "maxAmount", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsOptional({ groups: [LoyaltyProgramExposeGroupEnum.PUT] }),
    IsDefined({ groups: [LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsEnum(PromotionDiscountLevelEnum, { always: true }),
    __metadata("design:type", String)
], ReadLoyaltyPromotionDiscountDto.prototype, "level", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsOptional({ groups: [LoyaltyProgramExposeGroupEnum.PUT] }),
    IsDefined({ groups: [LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsEnum(PromotionDiscountBehaviourEnum, { always: true }),
    __metadata("design:type", String)
], ReadLoyaltyPromotionDiscountDto.prototype, "behaviour", void 0);
__decorate([
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.PUT] }),
    IsArray({ always: true }),
    Type(() => ReadLoyaltyPromotionTargetDto),
    ValidateNested({ always: true, each: true }),
    __metadata("design:type", Array)
], ReadLoyaltyPromotionDiscountDto.prototype, "targets", void 0);
//# sourceMappingURL=ReadLoyaltyPromotionDiscountDto.js.map